import React, { ReactElement } from 'react';

import { Avatar } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { DEFAULT_SMART_ASSISTANT_COLOR_THEME } from 'shared/constants/smart-assistant';
import { CustomizationFormValues, SmartAssistant, SmartAssistantVisualConfig } from 'shared/interfaces/SmartAssistant';
import { formatHexColor } from 'shared/utils/format';

interface UseSmartAssistantVisualConfigExtractorProps {
  smartAssistant?: SmartAssistant;
  customizationForm?: UseFormReturnType<CustomizationFormValues>;
  avatarUrl?: string | ReactElement;
}

export function useSmartAssistantVisualConfigExtractor({
  smartAssistant,
  customizationForm,
  avatarUrl
}: UseSmartAssistantVisualConfigExtractorProps) {
  return {
    assistantName: smartAssistant?.name || customizationForm?.values.name,
    assistantWelcomeMessage: smartAssistant?.welcomeMessage || customizationForm?.values.welcomeMessage,
    assistantAvatar: typeof avatarUrl === 'string' ? <Avatar src={avatarUrl} /> : avatarUrl,
    assistantMessageColor:
      formatHexColor(smartAssistant?.assistantMessageColor || customizationForm?.values.assistantMessageColor) ??
      DEFAULT_SMART_ASSISTANT_COLOR_THEME.assistantMessageColor,
    userMessageColor:
      formatHexColor(smartAssistant?.userMessageColor || customizationForm?.values.userMessageColor) ??
      DEFAULT_SMART_ASSISTANT_COLOR_THEME.userMessageColor,
    conversationBackgroundColor:
      formatHexColor(
        smartAssistant?.conversationBackgroundColor || customizationForm?.values.conversationBackgroundColor
      ) ?? DEFAULT_SMART_ASSISTANT_COLOR_THEME.conversationBackgroundColor,
    secondaryBackgroundColor:
      formatHexColor(smartAssistant?.secondaryBackgroundColor || customizationForm?.values.secondaryBackgroundColor) ??
      DEFAULT_SMART_ASSISTANT_COLOR_THEME.secondaryBackgroundColor,
    gradientColors:
      (smartAssistant?.gradientColors || customizationForm?.values.gradientColors)?.map(formatHexColor) ??
      DEFAULT_SMART_ASSISTANT_COLOR_THEME.gradientColors,
    showBadge: smartAssistant?.showBadge || customizationForm?.values.showBadge
  } as SmartAssistantVisualConfig;
}
